import { AmericanAngusEpd, NeogenEpd } from "generated/graphql";
import { Epd } from "./types";

export const camelCaseToLabel = (name: string): string => {
  const words = name.replace(/([A-Z])/g, " $1").trim();
  const formattedName = words.charAt(0).toUpperCase() + words.slice(1);
  return formattedName;
};

export const transformEpdData = (data: AmericanAngusEpd | NeogenEpd): Epd[] => {
  const transformedEpdData: Epd[] = [];
  const processedBaseNames: { [key: string]: Epd } = {};

  for (const key in data) {
    if (key === "__typename" || key === "createdAt" || key === "updatedAt") continue;

    const typeMatch = key.match(/(Acc|Epd|Pct)$/);
    const baseName = typeMatch ? key.substring(0, key.length - typeMatch[0].length) : key;
    const formattedBaseName = camelCaseToLabel(baseName);

    if (!processedBaseNames[baseName]) {
      processedBaseNames[baseName] = { name: formattedBaseName, epd: null, pct: null, acc: null };
      transformedEpdData.push(processedBaseNames[baseName]);
    }

    const value = parseFloat(data[key] as string);
    if (typeMatch) {
      const type = typeMatch[0];
      if (type === "Epd") processedBaseNames[baseName].epd = value;
      else if (type === "Pct") processedBaseNames[baseName].pct = value;
      else if (type === "Acc") processedBaseNames[baseName].acc = value;
    } else {
      processedBaseNames[baseName].epd = value;
    }
  }

  return transformedEpdData;
};
